import { useRef, useMemo, useEffect, useState } from "react";
import PaginationTable from "components/PaginationTable";
import Button from "components/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  editCurrencySpreadAction,
  getCurrencySpreadTypesAction,
} from "redux/actions/topupActions";
import { EDIT_CURENCY_SPREAD_STARTED } from "redux/ActionTypes";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import AppDropDown from "components/AppDropDown";
import { getCurrenciesRequestAction } from "redux/actions/usersActions";
import AppTextInput from "components/AppTextInput";
import { API_CURRENCY_SPREAD } from "services/API/apiPaths";

const CurrencySpread = () => {
  const paginationTableRef = useRef();
  const dispatch = useDispatch();
  const { rType, currencySpreadTypes, currencies } = useSelector((state) => ({
    rType: state.topUp.rType,
    currencySpreadTypes: state.topUp.currencySpreadTypes,
    currencies: state.currency.currenciesList,
  }));
  const isSaving = rType === EDIT_CURENCY_SPREAD_STARTED;
  const [open, setOpen] = useState(false);
  const [currency, setCurrency] = useState("");
  const [type, setType] = useState("");
  const [spreadValue, setSpreadValue] = useState("");

  useEffect(() => {
    dispatch(getCurrencySpreadTypesAction());
    dispatch(getCurrenciesRequestAction());
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "currency.code",
        header: "Currency Code",
        enableEditing: false,
      },
      {
        accessorKey: "spread",
        header: "Spread",
      },
      {
        accessorKey: "type.title",
        header: "Type",
        enableEditing: false,
        // muiEditTextFieldProps: {
        //   required: true,
        //   error: !!validationErrors?.firstName,
        // },
      },
    ],
    []
  );
  const handleSaveUser = ({ values, table }) => {
    const rowIndex = table.getState().rowSelection?.[0]; // or get from context
    const editingRow = table.getState().editingRow;

    const originalRow = editingRow?.original;

    const fullRow = {
      ...originalRow, // all fields from data, even hidden
      ...values, // updated fields
    };

    dispatch(
      editCurrencySpreadAction({
        currencyId: fullRow.currency.id,
        spread: fullRow.spread,
        type: fullRow.type.value,
        onSuccess: () => table.setEditingRow(null),
      })
    );
  };

  return (
    <>
      <PaginationTable
        ref={paginationTableRef}
        apiEndpoint={API_CURRENCY_SPREAD}
        title="Currency Spread"
        columns={columns}
        enableEditing
        onEditingRowSave={handleSaveUser}
        state={{ isSaving }}
        renderTopToolbar={
          <Grid item xs={12} display="flex" justifyContent="flex-end">
            <Button
              text={"+ Add Currency Spread"}
              onClick={() => setOpen(true)}
              color="secondary"
            />
          </Grid>
        }
      />
      <Dialog open={open} maxWidth="xs">
        <DialogTitle>Add Currency Spread</DialogTitle>
        <DialogContent></DialogContent>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item>
              <AppDropDown
                label={"Currency"}
                items={currencies}
                schema={{ label: "code", value: "id" }}
                onChange={(e) => setCurrency(e.target.value)}
              />
            </Grid>
            <Grid item>
              <AppDropDown
                label={"Type"}
                items={currencySpreadTypes}
                schema={{ label: "title", value: "value" }}
                onChange={(e) => setType(e.target.value)}
              />
            </Grid>
            <Grid item>
              <AppTextInput
                label={"Spread"}
                onChange={(e) => setSpreadValue(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button text="Cancel" onClick={() => setOpen(false)} variant="text" />
          <Button
            text="Save"
            onClick={() => {
              dispatch(
                editCurrencySpreadAction({
                  currencyId: currency,
                  spread: spreadValue,
                  type,
                  onSuccess: () => {
                    setOpen(false);
                    paginationTableRef.current.refetch();
                  },
                })
              );
            }}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CurrencySpread;
